import api, { unwrap } from './client';

export async function listMine(params = {}) {
  return unwrap(await api.get('/notifications/me', { params }));
}

export async function unreadCount() {
  return unwrap(await api.get('/notifications/me/unread-count'));
}

export async function markRead(id) {
  return unwrap(await api.post(`/notifications/${id}/read`));
}

export async function markAllRead() {
  return unwrap(await api.post('/notifications/me/read-all'));
}
